module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-76.2e6c0477.svg";